import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from './intl';

export const ErrorPropType = PropTypes.shape({
  code: PropTypes.string,
  defaultMessage: MessageDescriptorPropType,
});

/**
 * @typedef {object} ErrorPropType
 * @property {string} code
 * @property {MessageDescriptorPropType} defaultMessage
 */
